import React from 'react';
import './SpectateSpeedControl.css';

/**
 * Speed control component for spectate mode
 * Provides a slider/lever to control playback speed from 1% to 100%
 */
export function SpectateSpeedControl({ speed, onSpeedChange, isPaused, onTogglePause }) {
  const handleSpeedChange = (e) => {
    const newSpeed = parseInt(e.target.value, 10);
    onSpeedChange(newSpeed);
  };
  
  const handleSpeedInput = (e) => {
    const newSpeed = parseInt(e.target.value, 10);
    if (!isNaN(newSpeed) && newSpeed >= 1 && newSpeed <= 100) {
      onSpeedChange(newSpeed);
    }
  };
  
  return (
    <div className="spectate-speed-control">
      <div className="spectate-speed-control-header">
        <span className="spectate-speed-label">Playback Speed</span>
        <button 
          className="spectate-speed-pause-btn"
          onClick={(e) => {
            console.log('🔘 [UI] Pause button clicked!', { isPaused, timestamp: Date.now() });
            e.preventDefault();
            e.stopPropagation();
            onTogglePause();
          }}
          title={isPaused ? 'Resume' : 'Pause'}
        >
          {isPaused ? '▶' : '⏸'}
        </button>
      </div>
      
      <div className="spectate-speed-control-body">
        {/* Slider/Lever */}
        <input
          type="range"
          min="1"
          max="100"
          value={speed}
          onChange={handleSpeedChange}
          className="spectate-speed-slider"
          disabled={isPaused}
        />
        
        {/* Speed display */}
        <div className="spectate-speed-display">
          <input
            type="number"
            min="1"
            max="100"
            value={speed}
            onChange={handleSpeedInput}
            className="spectate-speed-input"
            disabled={isPaused}
          />
          <span className="spectate-speed-percent">%</span>
        </div>
      </div>
      
      {/* Speed presets */}
      <div className="spectate-speed-presets">
        <button 
          className="spectate-speed-preset"
          onClick={() => onSpeedChange(1)}
          disabled={isPaused}
        >
          1%
        </button>
        <button 
          className="spectate-speed-preset"
          onClick={() => onSpeedChange(25)}
          disabled={isPaused}
        >
          25%
        </button>
        <button 
          className="spectate-speed-preset"
          onClick={() => onSpeedChange(50)}
          disabled={isPaused}
        >
          50%
        </button>
        <button 
          className="spectate-speed-preset"
          onClick={() => onSpeedChange(75)}
          disabled={isPaused}
        >
          75%
        </button>
        <button 
          className="spectate-speed-preset"
          onClick={() => onSpeedChange(100)}
          disabled={isPaused}
        >
          100%
        </button>
      </div>
    </div>
  );
}
